import React, { useState, useEffect, useRef,Component  } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, Upload,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    LoadingOutlined
} from '@ant-design/icons';

import './styles.scss'



import moment from 'moment'
import {getData,editItem,addItem,deleteItem,getOptions,UploadPicture} from '../../../Redux/actions/crudActions'
import {errorParser} from '../../../utils/helpers'
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

// console.log(ClassicEditor.builtinPlugins.map( plugin => plugin.pluginName ));

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const Index = ({value,onChange}) => { 
    
    const dispatch = useDispatch()    
    const siteEditorRef = useRef(null);
    const { } = useSelector(
      state => ({
      
      }),
      shallowEqual
    )


    const [currentValue, setCurrentvalue] = useState(moment())

    useEffect(() => {
      console.log('changeval',value)
      if(value){
        var datetime = moment(value)
        setCurrentvalue(datetime)
      }
  
    }, [value])


    


    return ( 
      <DatePicker value={currentValue}
      onChange={onChange}
      />
 
    
 
     )
}
  
export default Index
  